/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import React, {useRef, useEffect, useContext} from "react";

import ApplicationRouterContext from "@Contexts/Router";
import APPLICATION_ROUTER_INTERFACE from "@ROUTER/Interfaces/Router";


import {Redirect} from "react-router-dom";

import {Row, Col} from "react-bootstrap";


import scrollToDomElement from "@Utilities/Animations/Scrolling";


import ErrorMessageComponent from "@Components/UI/Communicates/Messages/Error";
import FormResetComponent from "@Components/UI/Forms/Reset";
import FormSwitchPageComponent from "@Components/UI/Forms/SwitchPage";


import PasswordResetFormStep1Component from "@UIPages/NotAuthenticated/PasswordReset/Steps/Step1";
import PasswordResetFormStep2Component from "@UIPages/NotAuthenticated/PasswordReset/Steps/Step2";


import {PasswordResetFormStepType, PasswordResetErrorsInterface} from "@UIPages/NotAuthenticated/PasswordReset";
import PasswordResetFormStep3Component from "@UIPages/NotAuthenticated/PasswordReset/Steps/Step3";


type PasswordResetFormStepsProps = {
    passwordResetFormStep: PasswordResetFormStepType; passwordResetFormStepHandler(step: number, final?: boolean): void;
    passwordResetFormErrors: PasswordResetErrorsInterface; formResetHandler(): void;
    formUserLogin: string; formUserLoginHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    formUserPIN: string; formUserPINHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    formUserSmsCode: string; formUserSmsCodeHandler(e: React.ChangeEvent<HTMLInputElement> | string): void; formUserSmsCodeValidDate: string;
    formUserNewPassword: string, formUserNewPasswordHandler(e: React.ChangeEvent<HTMLInputElement>): void;
    formUserNewPasswordRepeat: string; formUserNewPasswordRepeatHandler(e: React.ChangeEvent<HTMLInputElement>): void,
};


export const PasswordResetStepsComponent: React.FC<PasswordResetFormStepsProps> = ({
    passwordResetFormStep, passwordResetFormStepHandler,
    passwordResetFormErrors, formResetHandler,
    formUserLogin, formUserLoginHandler,
    formUserPIN, formUserPINHandler,
    formUserSmsCode, formUserSmsCodeHandler, formUserSmsCodeValidDate,
    formUserNewPassword, formUserNewPasswordHandler,
    formUserNewPasswordRepeat, formUserNewPasswordRepeatHandler
}): JSX.Element | null => {


    const FIRST_STEP_CONTAINER_REF = useRef(null);
    const SECOND_STEP_CONTAINER_REF = useRef(null);
    const THIRD_STEP_CONTAINER_REF = useRef(null);


    useEffect(() => {
        let DOM_ELEMENT = null;
        if (passwordResetFormStep === 1) DOM_ELEMENT = FIRST_STEP_CONTAINER_REF;
        if (passwordResetFormStep === 2) DOM_ELEMENT = SECOND_STEP_CONTAINER_REF;
        if (passwordResetFormStep === 3) DOM_ELEMENT = THIRD_STEP_CONTAINER_REF;
        scrollToDomElement(DOM_ELEMENT, 100);
        return () => {};
    }, [passwordResetFormStep]);


    const ROUTER: APPLICATION_ROUTER_INTERFACE = useContext(ApplicationRouterContext);

    if (!ROUTER) return <Redirect to={"/404"} />;


    const REGISTER_PAGE_URL: string = ROUTER.NOT_AUTHENTICATED.REGISTER.URL;


    return (
        <Col xs={12} className={`password-reset-page-form-component user-form-component`}>
            <Row className={`password-reset-page-form user-form`}>

                {passwordResetFormStep === 1 &&
	            <PasswordResetFormStep1Component
                    forwardRef={FIRST_STEP_CONTAINER_REF}
                    passwordResetFormStep={passwordResetFormStep}
                    passwordResetFormStepHandler={passwordResetFormStepHandler}
                    passwordResetFormErrors={passwordResetFormErrors}
                    formUserLogin={formUserLogin}
                    formUserLoginHandler={formUserLoginHandler}
                    formUserPIN={formUserPIN}
                    formUserPINHandler={formUserPINHandler}
                />
                }

                {passwordResetFormStep === 2 &&
                <PasswordResetFormStep2Component
	                forwardRef={SECOND_STEP_CONTAINER_REF}
	                passwordResetFormStep={passwordResetFormStep}
	                passwordResetFormStepHandler={passwordResetFormStepHandler}
	                passwordResetFormErrors={passwordResetFormErrors}
                    formUserSmsCode={formUserSmsCode}
                    formUserSmsCodeHandler={formUserSmsCodeHandler}
                    formUserSmsCodeValidDate={formUserSmsCodeValidDate}
                />
                }

                {passwordResetFormStep === 3 &&
	            <PasswordResetFormStep3Component
		            forwardRef={THIRD_STEP_CONTAINER_REF}
		            passwordResetFormStep={passwordResetFormStep}
		            passwordResetFormStepHandler={passwordResetFormStepHandler}
		            passwordResetFormErrors={passwordResetFormErrors}
		            formUserNewPassword={formUserNewPassword}
                    formUserNewPasswordHandler={formUserNewPasswordHandler}
                    formUserNewPasswordRepeat={formUserNewPasswordRepeat}
                    formUserNewPasswordRepeatHandler={formUserNewPasswordRepeatHandler}
	            />
                }

                {!!passwordResetFormErrors?.passwordResetProcess &&
	            <ErrorMessageComponent messageText={passwordResetFormErrors?.passwordResetProcess} />
                }

                {passwordResetFormStep > 1 &&
	            <FormResetComponent formResetHandler={formResetHandler}/>
                }

                <FormSwitchPageComponent
                    switchLabel={`Nie masz konta?`}
                    switchButtonURL={REGISTER_PAGE_URL}
                    switchButtonText={`Zarejestruj się`}
                />

            </Row>
        </Col>
    );

};


export default PasswordResetStepsComponent;
